import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  FormControl,
  MenuItem,
  InputAdornment,
  Button,
  Grid,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from "../../hooks/useForm";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { CboLocalidades } from "../cbos/CboLocalidades";
import { CboProvincias } from "../cbos/CboProvincias";
import { useValidation } from "../../hooks/useValidation";
import {guardarAfiliadoNuevoAutogestion} from "../../actions/preAfiliado/afiliado";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from "react-material-ui-form-validator";
import { CboCategoriaAutogestion } from "./cbos/CboCategoriaAutogestion";
import { withRouter } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
}));

export const PanelDatosAutogestion = withRouter(React.memo((props) => {

  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();
 
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);

  // eslint-disable-next-line
  const [formValues, handleInputChange, reset, setearValor, setearValor2, setearValorDomicilio, setearValorDomicilio2] = useForm(afiliadoEncontrado);
  const {
    apellido_y_nombre,
    sexo,
    id_tipo_documento,
    nro_doc,
    fecha_nacimiento,
    id_estado_civil,
    cuil,
    id_sit_revista,
    domiciliosAfiliados: {
      calle,
      nro,
      telefono,
      celular,
      codigo_postal,
      mail,
      id_localidad,
      id_provincia,
    },
  } = formValues;

  
  const [
    valuesValidation,
    handleInputChangeValidation,
    ,
    setearValorValidation,
  ] = useValidation(afiliadoEncontrado);

  const [datosValidos, setDatosValidos] = useState(true);
  const [mail2,setMail2] = useState('');
  const [mail2Valido,setMail2Valido] = useState(false);
  const [edad, setEdad] = useState(moment().diff(moment(fecha_nacimiento), "years", false));

  const handleDateChange = (date) => {
    setearValor("fecha_nacimiento", date);
    setEdad(moment().diff(moment(date), "years", false));
  };

  useEffect(() => {
    setDatosValidos(true);

    const valorValidado = Object.keys(valuesValidation).find(
      (key) => valuesValidation[key] === true
    );
    if (valorValidado) {
      setDatosValidos(false);
    }
    // eslint-disable-next-line
  }, [dispatch, valuesValidation, datosValidos]);


  useEffect(() => {
    if(afiliadoEncontrado.estado===1){
      setMail2(mail)
    }
    // eslint-disable-next-line
  }, [afiliadoEncontrado])
 
  useEffect(() => {
    if(Object.keys(afiliadoEncontrado).length!==0 && mail2!==''){
      if(mail===mail2){
        setMail2Valido(true)
      }
    }
    // eslint-disable-next-line
  }, [mail2])
  //hasta aca manejo formulario con seleccion
  
  const { items } = useSelector((state) => state.localidades);

  const handleLocalidadChange = (e) => {
    if (items?.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearValorDomicilio2(
        "id_provincia",
        localidad.id_provincia,
        "id_localidad",
        localidad.id_localidad,
        "id_seccional",
        localidad.id_seccional
      );
    }
  };

  const handleCPChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    if (e.target.value === "" || reg.test(e.target.value)) {
      setearValorDomicilio("codigo_postal", e.target.value);
    }
  };

  const validateEmail = (email) => {
    // eslint-disable-next-line
    let reg = new RegExp(`[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+`);
    if (reg.test(email) || email?.length === 0) {
      setearValorValidation("mail", false);
    } else {
      setearValorValidation("mail", true);
    }
  };

  const confirmarMail = (e) =>{
      if(e.target.value===mail){
        setMail2Valido(true)
      }else{
        setMail2Valido(false)
      }
  }

  const onChangeMail = (e) => {
      setMail2(e.target.value);
  }

  const handleInputDomicilio = (e) => {
    setearValorDomicilio(e.target.name, e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (props.idPanel === "idTabIngreso" && props.idTabIngreso !== "idTabTitularModi") {
      dispatch(guardarAfiliadoNuevoAutogestion(formValues));
        props.history.push('/afiliaciones/AutoGestion/estado/preinscripto');
    } 
  };

  return (
    <Grid>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid  >
          <Grid container spacing={4} justify="center"> 
            <Grid item xs={3}>
              <TextField
                margin="normal"
                fullWidth
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Apellido y Nombre"
                name="apellido_y_nombre"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                value={apellido_y_nombre || ""}
                error={valuesValidation["apellido_y_nombre"]}
                helperText={
                  valuesValidation["apellido_y_nombre"] && "Obligatorio"
                }
                required={true}
                autoComplete="off"
                //autoFocus
                onChange={(e) => {
                  handleInputChange(e);
                  handleInputChangeValidation(e);
                }}
              />
            </Grid>
            {false&&<Grid item xs={1}>
              <FormControl
                error={valuesValidation["sexo"]}
                className={classes.formSelect}
                margin="normal"
                fullWidth={true}
              >
                <SelectValidator
                  value={sexo || ""}
                  disabled={props.idPanel === "idTabConsulta" ? true : false}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleInputChangeValidation(e);
                  }}
                  label="Sexo"
                  name="sexo"
                  validators={["required"]}
                  errorMessages={["El sexo es requerido"]}
                  fullWidth={true}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={1}>M</MenuItem>
                  <MenuItem value={2}>F</MenuItem>
                </SelectValidator>
                {valuesValidation["sexo"] && (
                  <FormHelperText>Obligatorio</FormHelperText>
                )}
              </FormControl>
            </Grid>}
            {false&&<Grid item xs={1}>
              <FormControl
                className={classes.formSelect}
                margin="normal"
                fullWidth={true}
                error={valuesValidation["id_tipo_documento"]}
              >
                <SelectValidator
                  value={id_tipo_documento || ""}
                  disabled={props.idPanel === "idTabConsulta" ? true : false}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleInputChangeValidation(e);
                  }}
                  label="Tip.Doc"
                  name="id_tipo_documento"
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  fullWidth={true}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={1}>DNI</MenuItem>
                  <MenuItem value={2}>CI</MenuItem>
                  <MenuItem value={3}>LE</MenuItem>
                  <MenuItem value={4}>LC</MenuItem>
                  <MenuItem value={5}>PAS</MenuItem>
                </SelectValidator>
                {valuesValidation["id_tipo_documento"] && (
                  <FormHelperText>Obligatorio</FormHelperText>
                )}
              </FormControl>
            </Grid>}
            {false&&<Grid item xs={1}>
              <TextValidator
                margin="normal"
                fullWidth
                label="Nro. Doc."
                name="nro_doc"
                value={nro_doc || ""}
                error={valuesValidation["nro_doc"]}
                helperText={valuesValidation["nro_doc"] && "Obligatorio"}
                required={true}
                disabled={
                  props.idPanel === "idTabConsulta" ||
                  props.idPanel === "idTabIngreso"
                    ? true
                    : false
                }
                autoComplete="off"
                onChange={(e) => {
                  handleInputChange(e);
                  handleInputChangeValidation(e);
                }}
                validators={["required", "isNumber", "maxNumber:99999999"]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "solo numeros",
                  "Verifique su dni",
                ]}
              />
            </Grid>}
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                fullWidth
                label="CUIL"
                name="cuil"
                value={cuil || ""}
                autoComplete="off"
                error={valuesValidation["cuil"]}
                helperText={valuesValidation["cuil"] && "Obligatorio"}
                required={true}
                disabled={
                  props.idPanel === "idTabConsulta" ||
                  props.idPanel === "idTabIngreso"
                    ? true
                    : false
                }
                onChange={(e) => {
                  handleInputChange(e);
                  handleInputChangeValidation(e);
                }}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999999",
                  "minNumber:9999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "solo numeros",
                  "Verifique su cuil",
                  "Verifique su cuil",
                ]}
              />
            </Grid>
            {false&&<Grid item xs={2}>
              <FormControl
                className={classes.formSelect}
                margin="normal"
                fullWidth={true}
                error={valuesValidation["id_estado_civil"]}
              >
                <SelectValidator
                  value={id_estado_civil || ""}
                  disabled={props.idPanel === "idTabConsulta" ? true : false}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleInputChangeValidation(e);
                  }}
                  label="Est.Civil"
                  name="id_estado_civil"
                  validators={["required"]}
                  errorMessages={["El estado requerido"]}
                  fullWidth={true}
                  //renderValue={(value) => `⚠️ ${id_estado_civil}`}
                >
                  <MenuItem value="">
                    <em>Seleccione</em>
                  </MenuItem>
                  <MenuItem value={1}>CASADO/A</MenuItem>
                  <MenuItem value={2}>SOLTERO/A</MenuItem>
                  <MenuItem value={3}>SEPARADO/A</MenuItem>
                  <MenuItem value={4}>DIVORCIADO/A</MenuItem>
                  <MenuItem value={5}>VIUDO/A</MenuItem>
                  <MenuItem value={6}>CONCUBINO/A</MenuItem>
                  <MenuItem value={7}>OTRO</MenuItem>
                </SelectValidator>
                {valuesValidation["id_estado_civil"] && (
                  <FormHelperText>Obligatorio</FormHelperText>
                )}
              </FormControl>
            </Grid>}
          </Grid>
          {/* division */}
         <Grid container spacing={4} justify="center">
         {false&&<Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fec. Nac."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  maxDate={new Date()} //maxDate
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={props.idPanel === "idTabConsulta" ? true : false}
                  value={
                    moment(fecha_nacimiento).isValid()
                      ? moment(fecha_nacimiento)
                      : 0
                  }
                  onChange={(date) => {
                    handleDateChange(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>}
            {false&&<Grid item xs={1}>
              <TextField
                margin="normal"
                fullWidth
                label="Edad"
                value={`${edad || ""} Años`}
                autoComplete="off"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
              />
            </Grid>}
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={mail || ""}
                error={valuesValidation["mail"]}
                helperText={valuesValidation["mail"] && "Invalido"}
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                onChange={(e) => {
                  handleInputDomicilio(e);
                  handleInputChangeValidation(e);
                }}
                onBlur={() => {
                  validateEmail(mail);
                }}
                //required={true}
                label="EMail"
                name="mail"
                autoComplete="off"
                fullWidth
                validators={["required", "isEmail"]}
                errorMessages={["El EMail es requerido", "Email invalido"]}
              />
            </Grid>
            {false&&<Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={telefono || ""}
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                label="Telefono (10 digitos sin 0)"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                name="telefono"
                autoComplete="off"
                maxLength="10"
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:9999999999",
                  "minNumber:999999999",
                ]}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      0
                    </InputAdornment>
                  ),
                }}
                errorMessages={[
                  "El telefono es requerido",
                  "Solo numeros",
                  "Verifique su telefono",
                  "Verifique su telefono",
                ]}
              />
            </Grid>}
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={mail2 || ""}
                error={!mail2Valido}
                helperText={!mail2Valido?"Email no coincide":''}
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                onChange={(e) => {
                  onChangeMail(e)
                  confirmarMail(e)
                }}
                onBlur={() => {
                  validateEmail(mail);
                }}
                //required={true}
                label="Confirmacion de EMail"
                name="mail2"
                autoComplete="off"
                fullWidth
                validators={["required", "isEmail"]}
                errorMessages={["El EMail es requerido", "Email invalido"]}
              />
              
            </Grid>
          </Grid>
          {/* Division */}
          <Grid container spacing={1} justify="center">
            <Grid item xs={4}>
                <TextValidator
                  fullWidth
                  margin="normal"
                  value={celular || ""}
                  onChange={(e) => {
                    handleInputDomicilio(e);
                  }}
                  label="Celular (10 digitos sin 0 ni 15)"
                  disabled={props.idPanel === "idTabConsulta" ? true : false}
                  name="celular"
                  maxLength="10"
                  autoComplete="off"
                  validators={[
                    "required",
                    "isNumber",
                    "maxNumber:9999999999",
                    "minNumber:999999999",
                  ]}
                  errorMessages={[
                    "El celular es requerido",
                    "Solo numeros",
                    "Verifique su celular",
                    "Verifique su celular",
                  ]}
                />
              </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                value={calle || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Calle"
                name="calle"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                error={valuesValidation["calle"]}
                helperText={valuesValidation["calle"] && "Obligatorio"}
                onChange={(e) => {
                  handleInputDomicilio(e);
                  handleInputChangeValidation(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
                validators={["required"]}
                errorMessages={["Requerido"]}
              />
            </Grid>
            
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={nro || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Numero"
                name="nro"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                error={valuesValidation["numero"]}
                helperText={valuesValidation["numero"] && "Obligatorio"}
                onChange={(e) => {
                  handleInputDomicilio(e);
                  handleInputChangeValidation(e);
                }}
                //required={true}
                autoComplete="off"
                fullWidth
                validators={["required"]}
                errorMessages={["Requerido"]}
              />
            </Grid>
            
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={codigo_postal || ""}
                onChange={(e) => {
                  handleCPChange(e);
                  handleInputChangeValidation(e);
                }}
                label="Cod. Postal"
                disabled={props.idPanel === "idTabConsulta" ? true : false}
                name="codigo_postal"
                inputProps={{ maxLength: 4 }}
                error={valuesValidation["codigo_postal"]}
                helperText={valuesValidation["codigo_postal"] && "Obligatorio"}
                //required={true}
                autoComplete="off"
                validators={["required"]}
                errorMessages={["El codigo postal es requerido"]}
              />
            </Grid>
            {false&&<Grid item xs={2}>
              <CboLocalidades
                manejadorInputChange={(e) => {
                  handleInputDomicilio(e);
                  handleInputChangeValidation(e);
                  handleLocalidadChange(e);
                }}
                name="id_localidad"
                manejadorInputChangeValidation={handleInputChangeValidation}
                valuesValidation={valuesValidation}
                valor={id_localidad}
                cp={codigo_postal}
                idPanel={props.idPanel}
              />
            </Grid>}
            {false&&<Grid item xs={2}>
              <CboProvincias
                manejadorInputChange={handleInputDomicilio}
                valor={id_provincia}
                name="id_provincia"
                manejadorInputChangeValidation={handleInputChangeValidation}
                valuesValidation={valuesValidation}
                idPanel={props.idPanel}
              />
            </Grid>}
          </Grid>
          {/* Division */}        
          <Grid container spacing={1} justify="center">
            <Grid item xs={8}>
              <CboCategoriaAutogestion
                manejadorInputChange={handleInputChange}
                manejadorInputChangeValidation={handleInputChangeValidation}
                valuesValidation={valuesValidation}
                valor={id_sit_revista}
                idPanel={props.idPanel}
              />
            </Grid>
          </Grid>
          <Button id="btnsubmit1" className={classes.hideButton} type="submit">
            Submit
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}));
